<template>
  <div class="row mb-4">
    <div class="col">
      <div class="card card-body pt-0 mt-4 bg-light">
        <h5 class="mt-4 mb-3">Comments</h5>

        <div v-if="ableToComment" class="card mb-3">
          <div class="card-body">
            <form @submit.prevent="add" class="w-100">
              <TextArea
                label="Add a Comment"
                v-model="form.comment"
                autofocus
                autocapitalize="off"
                rows="3"
                :errors="errors.comment"
                class="w-100"
              />
              <div class="row mt-2">
                <div class="col pr-0 d-flex flex-grow-0">
                  <LoadingButton
                    :loading="saving"
                    class="btn btn-primary text-nowrap"
                    type="sumbit"
                  >
                    Add a Comment
                  </LoadingButton>
                  <Button
                    @click.prevent="$emit('toggle')"
                    class="btn btn-secondary text-nowrap ml-1"
                    type="button"
                  >
                    Cancel
                  </Button>
                </div>
                <p class="col d-flex mb-0 flex-grow-1 align-self-end">
                  <small v-if="state.withCounterparty">
                    <input
                      type="checkbox"
                      v-model="form.hide_originator"
                      id="external"
                    />
                    <label for="external" class="mb-0">
                      Don't show comment to Originator
                    </label>
                  </small>
                  <small v-else>
                    <input
                      type="checkbox"
                      v-model="form.hide_counterparty"
                      id="external"
                    />
                    <label for="external" class="mb-0">
                      Don't show comment to Counterparty
                    </label>
                  </small>
                </p>
              </div>
            </form>
          </div>
        </div>

        <Comment
          v-for="comment in commentsData"
          :key="comment.id"
          :comment="comment"
        />
      </div>
    </div>
  </div>
</template>

<script>
import helpers from '@/Mixins/helpers';
import contractState from '@/Mixins/contractState';
import Comment from './Comment';
import TextArea from '@/Shared/Inputs/Textarea';
import LoadingButton from '@/Shared/LoadingButton';

export default {
  mixins: [helpers, contractState],

  components: {
    Comment,
    TextArea,
    LoadingButton,
  },

  props: {
    comments: {
      type: Array,
      default: () => [],
    },
    contract: [Number, String],
    block: [Number, String],
  },

  data() {
    return {
      form: {
        contract_id: this.contract,
        contract_block_id: this.block,
        comment: null,
        hide_counterparty: false,
        hide_originator: false,
      },
      saving: false,
      errors: {},
      commentsData: this.comments,
    };
  },

  mounted() {
    this.form.hide_counterparty = !this.state.withCounterparty;
    this.form.hide_originator = this.state.withCounterparty;

    this.$nextTick(() => {
      if (this.unread.length) {
        this.markCommentsAsRead();
      }
    });
  },

  computed: {
    ableToComment() {
      if (this.userHasRole('contract_lead')) {
        const showForStates = [
          'editing',
          'approved',
          'signed',
          'executed',
        ];
        return showForStates.includes(this.state.state);
      }

      if (this.userHasRole('approver')) {
        const showForStates = [
          'pending',
        ];
        return showForStates.includes(this.state.state);
      }

      return false;
    },

    unread() {
      const { id } = this.$page.props.auth.user;
      return this.commentsData.filter((comment) => !comment.read_by.includes(id));
    },
  },

  methods: {
    markCommentsAsRead() {
      // eslint-disable-next-line array-callback-return
      Object.keys(this.commentsData).map((i) => {
        if (!this.commentsData[i].read_at) {
          window.axios
            .put(`/comment/${this.commentsData[i].id}/read`)
            .then(() => {
              //
            })
            .catch((error) => {
              this.errors = error.response.data.errors;
            });
        }
      });

      this.$nextTick(() => {
        this.$emit('commentsUpdated', this.commentsData);
      });
    },

    add() {
      this.saving = true;
      this.$nextTick(() => {
        window.axios
          .post('/comment/', this.form)
          .then(({ data }) => {
            this.saving = false;
            this.commentsData.unshift(data);
            this.form.comment = '';
          })
          .catch((error) => {
            this.saving = false;
            this.errors = error.response.data.errors;
          });
      });
    },
  },
};
</script>
